import { FC } from "react"
import { UploadResults } from "../../../module/external/containers/uploadResults"

export const UploadResultsPage: FC = () => <UploadResults />
